import React, { useCallback, useState } from 'react';
import { requestBed } from '../../actions/beds';
import { AddressAutofill } from '@mapbox/search-js-react';
import { useSelector } from "react-redux";
import { UserOutlined, PhoneOutlined, CalendarOutlined, EnvironmentOutlined, MedicineBoxOutlined, CommentOutlined, CheckCircleOutlined } from "@ant-design/icons";

const inputStyle = {
    width: '100%',
    border: '1px solid #e8e8e8',
    borderRadius: 8,
    padding: '10px 14px',
    fontSize: 14,
    color: '#1a1a2e',
    backgroundColor: '#fff',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s',
};

const labelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    fontSize: 12,
    fontWeight: 600,
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: 6,
};

const sectionStyle = {
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    border: '1px solid #f0f0f0',
    padding: '20px 20px',
    marginBottom: 16,
};

const fieldStyle = {
    marginBottom: 16,
};

const RequestBedForm = (props) => {
    const user = useSelector(state => state.user.user);
    const [submitted, setSubmitted] = useState(false);

    const validateForm = useCallback((event) => {
        event.preventDefault();
        const form = event.target;
        requestBed(form, user).then((result) => {
            if (result) {
                form.client.value = '';
                form.phone.value = '';
                form.date.value = '';
                form[' address-search'].value = '';
                form.city.value = '';
                form.postcode.value = '';
                form.comment.value = '';
                setSubmitted(true);
                setTimeout(() => setSubmitted(false), 3000);
            }
        });
    }, []);

    return (
        <form onSubmit={validateForm}>

            {/* Section Client */}
            <div style={sectionStyle}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e', marginBottom: 16, paddingBottom: 10, borderBottom: '1px solid #f5f5f5' }}>
                    Informations client
                </div>
                <div style={fieldStyle}>
                    <label style={labelStyle}>
                        <UserOutlined /> Client
                    </label>
                    <input
                        type="text"
                        name="client"
                        id="clientInput"
                        placeholder="Nom du client"
                        style={inputStyle}
                    />
                </div>
                <div style={fieldStyle}>
                    <label style={labelStyle}>
                        <PhoneOutlined /> Téléphone
                    </label>
                    <input
                        type="tel"
                        name="phone"
                        inputMode="tel"
                        autoComplete="tel"
                        placeholder="06 12 34 56 78"
                        style={inputStyle}
                    />
                </div>
                <div style={{ ...fieldStyle, marginBottom: 0 }}>
                    <label style={labelStyle}>
                        <CalendarOutlined /> Date et heure
                    </label>
                    <input
                        name="date"
                        type="datetime-local"
                        style={inputStyle}
                    />
                </div>
            </div>

            {/* Section Adresse */}
            <div style={sectionStyle}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e', marginBottom: 16, paddingBottom: 10, borderBottom: '1px solid #f5f5f5' }}>
                    Adresse
                </div>
                <div style={fieldStyle}>
                    <label style={labelStyle}>
                        <EnvironmentOutlined /> Rue
                    </label>
                    <AddressAutofill accessToken="pk.eyJ1IjoibG91aXNjcmVtZXJzIiwiYSI6ImNsZjlzdXJzNTAzeTAzb3FkcGs4ZDRrN2UifQ.T1bvG4WwOLUKMGj83SxZHw">
                        <input
                            name=""
                            placeholder="Adresse"
                            type="text"
                            autoComplete="address-line1"
                            style={inputStyle}
                        />
                    </AddressAutofill>
                </div>
                <div style={{ display: 'flex', gap: 12, marginBottom: 0 }}>
                    <div style={{ flex: '0 0 130px' }}>
                        <label style={labelStyle}>Code postal</label>
                        <input
                            name="postcode"
                            placeholder="Code postal"
                            type="text"
                            autoComplete="postal-code"
                            style={inputStyle}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={labelStyle}>Ville</label>
                        <input
                            name="city"
                            placeholder="Ville"
                            type="text"
                            autoComplete="address-level2"
                            style={inputStyle}
                        />
                    </div>
                </div>
            </div>

            {/* Section Détails */}
            <div style={sectionStyle}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e', marginBottom: 16, paddingBottom: 10, borderBottom: '1px solid #f5f5f5' }}>
                    Détails
                </div>
                <div style={fieldStyle}>
                    <label style={labelStyle}>
                        <MedicineBoxOutlined /> Pharmacie
                    </label>
                    <select
                        name="pharmacy"
                        id="pharmacy"
                        style={{ ...inputStyle, cursor: 'pointer', appearance: 'auto' }}
                    >
                        <option value="Cremers">Cremers</option>
                        <option value="Violaines">Violaines</option>
                        <option value="Mont à camp">Mont à Camp</option>
                        <option value="Grand Stade">Grand Stade</option>
                    </select>
                </div>
                <div style={{ marginBottom: 0 }}>
                    <label style={labelStyle}>
                        <CommentOutlined /> Commentaire
                    </label>
                    <textarea
                        name="comment"
                        id="comment"
                        placeholder="Informations complémentaires..."
                        rows={3}
                        style={{ ...inputStyle, resize: 'vertical' }}
                    />
                </div>
            </div>

            {/* Submit */}
            {submitted && (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    backgroundColor: '#eafaf1',
                    border: '1px solid #27ae60',
                    borderRadius: 8,
                    padding: '10px 16px',
                    color: '#27ae60',
                    fontSize: 14,
                    fontWeight: 600,
                    marginBottom: 12,
                }}>
                    <CheckCircleOutlined />
                    Demande envoyée avec succès !
                </div>
            )}
            <button
                type="submit"
                style={{
                    width: '100%',
                    backgroundColor: '#1a1a2e',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 10,
                    padding: '13px',
                    fontSize: 15,
                    fontWeight: 700,
                    cursor: 'pointer',
                    letterSpacing: '0.02em',
                }}
            >
                Envoyer la demande
            </button>
        </form>
    );
};

export {
    RequestBedForm
};
